export default "__VITE_ASSET__fdr54uaG__"